<div class="flex w-full justify-center items-center">
  <p>{{ 'offlineBanner.offlineMessage' | translate }}</p>
</div>
